module.exports = __webpack_public_path__ + "deaf977a696e528925bc88c16739bd3e.png";